import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectAssignmentJydacomInfoModifications } from '../selectors/assignment.selectors';
import { patchUpdateAssignmentsJydacomInfo } from '../services/jydacom/patchUpdateAssignmentsJydacomInfo.service';

export const saveAssignmentJydacomInfoModifications = createAsyncThunk(
  'assignments/saveAssignmentJydacomInfoModifications',
  async (projectId, { getState }) => {
    const assignmentJydacomInfoModifications =
      selectAssignmentJydacomInfoModifications(getState());

    console.log(
      'assignmentJydacomInfoModifications',
      Object.values(assignmentJydacomInfoModifications)
    );

    const updatedAssignments = await patchUpdateAssignmentsJydacomInfo(
      projectId,
      Object.values(assignmentJydacomInfoModifications)
    );

    return updatedAssignments;
  }
);
